// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-queryBuilder-components-ValueInput-ValueInput-module__valueInputWrap--ZkQGD {
  flex: 1 1 0;
  min-width: 320px;
  width: 100%;
}
.src-business-queryBuilder-components-ValueInput-ValueInput-module__valueInput--w0JmD {
  width: 100%;
}
/*# sourceMappingURL=ValueInput.module.css.map */`, "",{"version":3,"sources":["webpack://./ValueInput.module.less","webpack://./src/business/queryBuilder/components/ValueInput/ValueInput.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,WAAA;ACCF;ADEA;EACE,WAAA;ACAF;AACA,gDAAgD","sourcesContent":[".valueInputWrap {\n  flex: 1 1 0;\n  min-width: 320px;\n  width: 100%;\n}\n\n.valueInput {\n  width: 100%;\n}\n",".valueInputWrap {\n  flex: 1 1 0;\n  min-width: 320px;\n  width: 100%;\n}\n.valueInput {\n  width: 100%;\n}\n/*# sourceMappingURL=ValueInput.module.css.map */"],"sourceRoot":""}]);
// Exports
export var valueInputWrap = `src-business-queryBuilder-components-ValueInput-ValueInput-module__valueInputWrap--ZkQGD`;
export var valueInput = `src-business-queryBuilder-components-ValueInput-ValueInput-module__valueInput--w0JmD`;
export default ___CSS_LOADER_EXPORT___;
